import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ErrorPage from "Components/Shared/error";
import Loading from "Components/Shared/loading";
import StickyHeadTable from "Components/Shared/table";
import { useQuery } from "react-query";
import { request } from "Utils";
import Menu from "./menu";
import NoContentFound from "Components/Shared/noContentFound";
import AddConfig from "./add";
import { useDailog, useToast } from "Utils/hooks";
import Toast from "Components/Shared/toast";
import { SupportInt } from "./type";

const getAdmin = async () => {
  const { result } = await request.get({
    url: `/support/support_organisations/`,
  });
  return result;
};

const SupportOrganization = () => {
  const { isOpen, closeDialog, openDialog } = useDailog();
  const { toggleToast, toastMessage } = useToast();
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["organization"],
    queryFn: getAdmin,
    retry: 2,
    // staleTime: 86400000,
  });

  const columns = [
    { minWidth: 20, name: "No", key: "index" },
    { minWidth: 100, name: "Name", key: "name" },
    { minWidth: 50, name: "Email", key: "email" },
    { minWidth: 50, name: "Type", key: "name" },
    { minWidth: 50, name: "Number", key: "phone_number" },
    { minWidth: 50, name: "Country", key: "country" },
    { minWidth: 50, name: "Text number", key: "text_number" },
    { minWidth: 50, name: "Action", key: "action" },
  ];

  const users = data?.map((support: SupportInt, index: number) => ({
    index: ++index,
    ...support,
    action: (
      <Menu
        refetch={refetch}
        data={support as any}
        toggleToast={toggleToast}
        isSupperAdmin={true}
      />
    ),
  }));
  if (isLoading) return <Loading />;
  if (error) return <ErrorPage error={error} />;
  return (
    <>
      <Container maxWidth="lg">
        <Box textAlign="right" mb={3}>
          <Button variant="contained" onClick={openDialog}>
            Add New Support Organization
          </Button>
        </Box>
        {users?.length ? (
          <Box pb={5} sx={{ height: users?.length <= 7 ? "77vh" : "" }}>
            <StickyHeadTable
              refetch={refetch}
              data={users}
              dataLength={data?.totalCount}
              columns={columns}
            />
          </Box>
        ) : (
          <NoContentFound />
        )}
      </Container>
      <AddConfig
        isOpen={isOpen}
        closeDialog={closeDialog}
        toggleToast={toggleToast}
        refetch={refetch}
      />
      {Boolean(toastMessage) && (
        <Toast
          open={Boolean(toastMessage)}
          message={toastMessage}
          onClose={() => toggleToast("")}
        />
      )}
    </>
  );
};

export default SupportOrganization;
